import { IDeepCopy } from "@common/interfaces/i-deep-copy";

export class ENPSLanguage implements IDeepCopy<ENPSLanguage> {
  public id: string = null;
  public title: string = null;

  constructor(id: string, displayName: string) {
    this.id = id;
    this.title = displayName;
  }

  public deepCopy(): ENPSLanguage {
      let ret = new ENPSLanguage(this.id, this.title);
      return ret;
  }
}
